module.exports = __webpack_public_path__ + "img/no_signature.eb1fe6ba.png";